require('./adminbar');
require('./mobile-scroll');
require('./dieste-slider');
require('./posts');
require('./leader-board');
require('./paragraph2Col');